import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FORM_DATA_DROPDWON_SELECT_2 } from '../../data/data';

type SurveyOption = {
  label: string;
  label_en: string;
  value: string;
  code: string;
  selected?: boolean;
};

type SurveyModule = {
  type: string;
  id: number;
  label: string;
  label_en: string;
  required?: boolean;
  options: SurveyOption[];
};

@Component({
  selector: 'app-sign-in-step-survey-2',
  templateUrl: './sign-in-step-survey-2.component.html',
  styleUrls: ['./sign-in-step-survey-2.component.scss'],
})
export class SignInStepSurvey2Component implements OnInit, OnDestroy {
  readonly formData = FORM_DATA_DROPDWON_SELECT_2;
  readonly modules: SurveyModule[] = FORM_DATA_DROPDWON_SELECT_2.modules as SurveyModule[];

  //@Input() surveyDecision = '';
  //@Input() surveyPhrase = '';
  @Input() surveyDecision: {value: string;code: string;} = { value: '', code: '' };
  @Input() surveyPhrase: {value: string;code: string;} = { value: '', code: '' };

  //@Output() surveyDecisionChange = new EventEmitter<string>();
  //@Output() surveyPhraseChange = new EventEmitter<string>();
  @Output() surveyDecisionChange = new EventEmitter<{ value: string; code: string }>();
  @Output() surveyPhraseChange = new EventEmitter<{ value: string; code: string }>();

  @Output() goToStep = new EventEmitter<number>();

  private langSub?: Subscription;

  constructor(
    public translateService: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.langSub = this.translateService.onLangChange.subscribe(() =>
      this.cdr.markForCheck(),
    );
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  isSpanish(): boolean {
    return this.translateService.getCurrentLang() === 'es';
  }

  moduleLabel(mod: SurveyModule): string {
    return this.isSpanish() ? mod.label : mod.label_en;
  }

  optionLabel(opt: SurveyOption): string {
    return this.isSpanish() ? opt.label : opt.label_en;
  }

  headerTitle(): string {
    return this.isSpanish() ? this.formData.title : this.formData.title_en;
  }

  headerSubtitle(): string {
    return this.isSpanish() ? this.formData.subtitle : this.formData.subtitle_en;
  }

  get isSurveyComplete(): boolean {
    return (
      //!!this.surveyDecision?.trim() && !!this.surveyPhrase?.trim()
      !!this.surveyDecision?.value.trim() && !!this.surveyPhrase?.value.trim()
    );
  }

  questionNumber(moduleIndex: number): number {
    return moduleIndex + 4;
  }

  //selectedValue(moduleIndex: number): string {
  selectedValue(moduleIndex: number): string | { value: string; code: string } {
    switch (moduleIndex) {
      case 0:
        //return this.surveyDecision;
        return { value: this.surveyDecision.value, code: this.surveyDecision.code };
      case 1:
        //return this.surveyPhrase;
        return { value: this.surveyPhrase.value, code: this.surveyPhrase.code };
      default:
        return '';
    }
  }

  onOptionChange(moduleIndex: number, value: string): void {
    
    const module = this.formData.modules[moduleIndex];
    const selectedOption = module.options.find((option: any) => option.value === value);

    if (!selectedOption) return;

    switch (moduleIndex) {
      case 0:
        //this.surveyDecisionChange.emit(value);
        this.surveyDecisionChange.emit({ value: selectedOption.value, code: selectedOption.code });
        break;
      case 1:
        //this.surveyPhraseChange.emit(value);
        this.surveyPhraseChange.emit({ value: selectedOption.value, code: selectedOption.code });
        break;
      default:
        break;
    }
  }
}
